module.exports = __webpack_public_path__ + "img/chahua.e8333605.svg";